import React, { useEffect } from 'react'
import Loading from '../Common/Loading/Loading'
import api from '../../middleware/api'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import LoadingSpinner from '../Common/Loading/LoadingSpinner'

const VerifyAccount = () => {


    const [searchParam] = useSearchParams()
    const token = searchParam.get('token')
    const navigate = useNavigate()
console.log(token)
    useEffect(() => {
        // Call the API to verify the account
        // If the account is verified, redirect to the login page
        // If the account is not verified, display an error message
        const verifyAccount = async () => {
            try {
                const response = await api.post('/auth/verify-account', { token: token })
                if (response.status === 200) {
                    navigate('/se-connecter')
                    toast.success('Votre compte a été vérifié avec succès')
                } else {
                    toast.error('Une erreur est survenue lors de la vérification de votre compte')
                    navigate('/se-connecter')
                }
            } catch (e) {
                toast.error('Une erreur est survenue lors de la vérification de votre compte')
                navigate('/se-connecter')
            }
        }
        if (!token) {
            toast.error('Une erreur est survenue lors de la vérification de votre compte')
        }else {
            verifyAccount()
        }
       
    }, [token])


    return (
        <LoadingSpinner style="medium" />
    )
}

export default VerifyAccount
